/**
 * Table configuration constants
 * Extracted from MainTable.js and Table/index.js for better maintainability
 */

// Filter options
export const ROW_FILTER_OPTIONS = {
  ALL: "ALL",
};

// Status codes for block operations
export const BLOCK_STATUS = {
  SUCCESS: "0",
  SUCCESS_WITH_WARNING: "1",
  ERROR: "-1",
  VALIDATION_ERROR: "-2",
};

// Error codes for API responses
export const ERROR_CODES = {
  NETWORK_ERROR: 500,
  HTTP_ERROR: 501,
};

// Access levels for user permissions
export const ACCESS_LEVELS = {
  READ_ONLY: 1,
  READ_WRITE: 2,
};

// Special route flag
export const SPECIAL_FLAGS = {
  YES: "Y",
  NO: "N",
};

// Pullout status options
export const PULLOUT_STATUS = {
  PENDING: "PENDING",
  RESET: "RESET",
};

// Modal styling constants
export const MODAL_STYLES = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.45)",
    zIndex: 9999,
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: 0,
    border: "none",
    borderRadius: "8px",
    boxShadow: "0 8px 30px rgba(0, 0, 0, 0.2)",
    maxWidth: "480px",
    width: "90vw",
    overflow: "hidden",
  },
};

// Scroll behavior constants
export const SCROLL_CONFIG = {
  FIRST_EMPTY_ROW_OFFSET: 5,
  SCROLL_BEHAVIOR: "smooth",
  // Box Jump-To shows this many rows of context above the target row.
  JUMP_CONTEXT_ROWS: 3,
};

// Locations that require specific fields to be filled out.
// To add a new requirement, add a new entry with the location value as key.
// Each entry contains an array of { field, label } objects.
export const LOCATION_REQUIRED_FIELDS = {
  LOOK: [{ field: "noteToOperator", label: "Note to Operators" }],
};
